export default function PasswordReset() {
  return (
    <div id="pw-reset-div">
      <style>
        {`
                #pw-reset-div {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;
                    align-items: center;

                }
                #pw-reset-form {
                    display: flex;
                    flex-direction: column;
                    gap: 15px;
                    width: 50%;
                }
                #pw-reset-form input {
                    padding: 8px;
                }
                #pw-reset-submit-btn{
                    padding: 8px;
                    font-weight: 500;
                }
                `}
      </style>
      <h2>Password Reset</h2>
      <form id="pw-reset-form">
        <input name="oldPassword" placeholder="Old Password"></input>
        <input name="newPassword" placeholder="New Password"></input>
        <input
          name="repeatNewPassword"
          placeholder="Repeat New Password"
        ></input>
        <button id="pw-reset-submit-btn">Reset Password</button>
      </form>
    </div>
  );
}
